export const REFRESH_TOKEN_EXPIRED_CODE = 4401;
export const REFRESH_TOKEN_EXPIRED_MESSAGE = "refresh_token_expired";
export const LOGIN_ROUTE = "/login";
